import React from "react";
import { Button } from "reactstrap";

const ViewParentOrder = ({ orderDetail }) => {
  return (
    <>
      <Button
        color="link"
        onClick={() =>
          window.open(`/collection-order/${orderDetail?.parent_id}`, "_blank")
        }
      >
        Xem đơn cha
      </Button>
    </>
  );
};

export default ViewParentOrder;
